module.exports = __webpack_public_path__ + "img/1.074464a5.png";